/**
 * Construction Spec Constants
 *
 * Auto-generated from backend API registrations.
 * Defines which nested relationships are allowed during create/modify operations.
 *
 * DO NOT EDIT - Changes will be overwritten during codegen.
 */

// ConstructionSpec and ObjectMode are the canonical contract types defined in
// @sourcepilot/framework — re-exported here so existing callers can still
// import them from this module without touching their imports.
export type { ConstructionSpec, ObjectMode } from '@sourcepilot/framework/resolvers';
import type { ConstructionSpec } from '@sourcepilot/framework/resolvers';

/**
 * ConstructionSpecs for CREATE operations
 * Maps model name to its allowed nested creation structure
 */
export const CREATE_CONSTRUCTION_SPECS: Record<string, ConstructionSpec | undefined> = {
  Action: {
    parent: {
      object_mode: "existing_only",
    },
    sub_actions: {
      input_parameters: undefined,
      output_parameters: undefined,
      satisfies: {
        object_mode: "existing_only",
      },
      verifies: {
        object_mode: "existing_only",
      },
      performed_by: {
        object_mode: "existing_only",
      },
    },
    input_parameters: undefined,
    output_parameters: undefined,
    satisfies: {
      object_mode: "existing_only",
    },
    verifies: {
      object_mode: "existing_only",
    },
    performed_by: {
      object_mode: "existing_only",
    },
  },
  AttributeValue: {
    attribute: {
      object_mode: "existing_only",
    },
    owner: {
      object_mode: "existing_only",
    },
    unit_override: {
      object_mode: "existing_only",
    },
  },
  ChatSkillsTask: {
    thread: {
      steps: {
        object_mode: "new_only",
        context_items: undefined,
      },
    },
    currently_attached_to: undefined,
  },
  ChatTask: {
    thread: {
      steps: {
        object_mode: "new_only",
        context_items: undefined,
      },
    },
    currently_attached_to: undefined,
  },
  Concern: {
    container: {
      object_mode: "existing_only",
    },
    stakeholders: {
      object_mode: "existing_only",
    },
  },
  Connection: {
    port_a: {
      object_mode: "existing_only",
    },
    port_b: {
      object_mode: "existing_only",
    },
    satisfies: {
      object_mode: "existing_only",
    },
  },
  Constraint: {
    formalises: {
      object_mode: "existing_only",
    },
    mentions: {
      object_mode: "existing_only",
    },
  },
  ControlPort: {
    owner: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
  },
  DerivedExpression: {
    result: {
      max_count: 1,
      object_mode: "new_only",
      owner: {
        object_mode: "existing_only",
      },
      attribute: {
        object_mode: "existing_only",
      },
    },
    mentions: {
      object_mode: "existing_only",
    },
  },
  DiscreteAttribute: undefined,
  GlossaryTerm: undefined,
  InterfacePort: {
    owner: {
      object_mode: "existing_only",
    },
    standard: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
    satisfies: {
      object_mode: "existing_only",
    },
  },
  Item: {
    canonical_unit: {
      object_mode: "existing_only",
    },
  },
  ItemFlow: {
    source_parameter: {
      object_mode: "existing_only",
    },
    target_parameter: {
      object_mode: "existing_only",
    },
    item: {
      object_mode: "existing_only",
    },
    unit: {
      object_mode: "existing_only",
    },
    realized_by: {
      object_mode: "existing_only",
    },
  },
  LogicalPart: {
    parent: {
      object_mode: "existing_only",
    },
    children: {
      behavioral_ports: undefined,
      interface_ports: undefined,
      performs: {
        object_mode: "existing_only",
      },
      satisfies: {
        object_mode: "existing_only",
      },
      allocated_to: {
        object_mode: "existing_only",
      },
      requirements: {
        derives_from: {
          object_mode: "existing_only",
        },
        sources: {
          object_mode: "existing_only",
        },
      },
    },
    behavioral_ports: undefined,
    interface_ports: undefined,
    performs: {
      object_mode: "existing_only",
    },
    satisfies: {
      object_mode: "existing_only",
    },
    allocated_to: {
      object_mode: "existing_only",
    },
    requirements: {
      derives_from: {
        object_mode: "existing_only",
      },
      sources: {
        object_mode: "existing_only",
      },
    },
  },
  NumericAttribute: {
    canonical_unit: {
      object_mode: "existing_only",
    },
  },
  PDMAction: {
    requirements: undefined,
    sub_actions: undefined,
    performed_by: undefined,
  },
  PDMPart: {
    ports: undefined,
    sub_parts: undefined,
  },
  PDMProduct: {
    requirements: undefined,
    actions: undefined,
    supply_chain: undefined,
  },
  PDMRequirement: undefined,
  PDMSupplyChainCriteria: undefined,
  PhysicalPart: {
    parent: {
      object_mode: "existing_only",
    },
    children: undefined,
  },
  PhysicsPort: {
    owner: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
  },
  Project: undefined,
  RFLPTask: {
    thread: {
      steps: {
        object_mode: "new_only",
        context_items: undefined,
      },
    },
    currently_attached_to: undefined,
  },
  Requirement: {
    container: {
      object_mode: "existing_only",
    },
    derives_from: {
      object_mode: "existing_only",
    },
    refines: {
      object_mode: "existing_only",
    },
    conflicts_with: {
      object_mode: "existing_only",
    },
    sources: {
      object_mode: "existing_only",
    },
    transformed_from: {
      object_mode: "existing_only",
    },
    frames_concerns: {
      object_mode: "existing_only",
    },
    sub_requirements: {
      derives_from: {
        object_mode: "existing_only",
      },
      refines: {
        object_mode: "existing_only",
      },
      conflicts_with: {
        object_mode: "existing_only",
      },
      sources: {
        object_mode: "existing_only",
      },
      transformed_from: {
        object_mode: "existing_only",
      },
      frames_concerns: {
        object_mode: "existing_only",
      },
    },
  },
  SoftwarePart: {
    parent: {
      object_mode: "existing_only",
    },
    children: undefined,
  },
  SourceDocument: undefined,
  Standard: undefined,
  Succession: {
    source_action: {
      object_mode: "existing_only",
    },
    target_action: {
      object_mode: "existing_only",
    },
    parent_action: {
      object_mode: "existing_only",
    },
    mentions: {
      object_mode: "existing_only",
    },
  },
  Thread: {
    steps: {
      max_count: 50,
      model_requests: {
        max_count: 10,
      },
    },
    context_items: {
      max_count: 20,
    },
  },
  Unit: undefined,
  VersioningCommit: {
    island_root: {
      object_mode: "existing_only",
    },
  },
  VersioningRelease: {
    island_root: {
      object_mode: "existing_only",
    },
  },
};

/**
 * ConstructionSpecs for MODIFY operations
 * Maps model name to its allowed nested modification structure
 */
export const MODIFY_CONSTRUCTION_SPECS: Record<string, ConstructionSpec | undefined> = {
  Action: {
    parent: {
      object_mode: "existing_only",
    },
    sub_actions: {
      input_parameters: undefined,
      output_parameters: undefined,
      satisfies: {
        object_mode: "existing_only",
      },
      verifies: {
        object_mode: "existing_only",
      },
      performed_by: {
        object_mode: "existing_only",
      },
    },
    input_parameters: undefined,
    output_parameters: undefined,
    satisfies: {
      object_mode: "existing_only",
    },
    verifies: {
      object_mode: "existing_only",
    },
    performed_by: {
      object_mode: "existing_only",
    },
  },
  ActionInputParameter: {
    owner_action: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
    item: {
      object_mode: "existing_only",
    },
  },
  ActionOutputParameter: {
    owner_action: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
    item: {
      object_mode: "existing_only",
    },
  },
  AttributeValue: {
    attribute: {
      object_mode: "existing_only",
    },
    owner: {
      object_mode: "existing_only",
    },
    unit_override: {
      object_mode: "existing_only",
    },
  },
  ChatSkillsTask: {
    thread: {
      steps: {
        object_mode: "new_only",
        context_items: undefined,
      },
    },
    currently_attached_to: undefined,
  },
  ChatTask: {
    thread: {
      steps: {
        object_mode: "new_only",
        context_items: undefined,
      },
    },
    currently_attached_to: undefined,
  },
  Concern: {
    container: {
      object_mode: "existing_only",
    },
    stakeholders: {
      object_mode: "existing_only",
    },
    sources: {
      object_mode: "existing_only",
    },
    transformed_from: {
      object_mode: "existing_only",
    },
  },
  Connection: {
    port_a: {
      object_mode: "existing_only",
    },
    port_b: {
      object_mode: "existing_only",
    },
    satisfies: {
      object_mode: "existing_only",
    },
  },
  Constraint: {
    formalises: {
      object_mode: "existing_only",
    },
    mentions: {
      object_mode: "existing_only",
    },
  },
  ControlPort: {
    owner: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
  },
  DerivedExpression: {
    result: {
      max_count: 1,
      object_mode: "new_only",
      owner: {
        object_mode: "existing_only",
      },
      attribute: {
        object_mode: "existing_only",
      },
    },
    mentions: {
      object_mode: "existing_only",
    },
  },
  DiscreteAttribute: undefined,
  GlossaryTerm: undefined,
  Group: {
    holders: {
      object_mode: "existing_only",
    },
  },
  InterfacePort: {
    owner: {
      object_mode: "existing_only",
    },
    standard: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
    satisfies: {
      object_mode: "existing_only",
    },
  },
  Item: {
    canonical_unit: {
      object_mode: "existing_only",
    },
  },
  ItemFlow: {
    source_parameter: {
      object_mode: "existing_only",
    },
    target_parameter: {
      object_mode: "existing_only",
    },
    item: {
      object_mode: "existing_only",
    },
    unit: {
      object_mode: "existing_only",
    },
    realized_by: {
      object_mode: "existing_only",
    },
  },
  LogicalPart: {
    parent: {
      object_mode: "existing_only",
    },
    children: {
      behavioral_ports: undefined,
      interface_ports: undefined,
      performs: {
        object_mode: "existing_only",
      },
      satisfies: {
        object_mode: "existing_only",
      },
      allocated_to: {
        object_mode: "existing_only",
      },
      requirements: {
        derives_from: {
          object_mode: "existing_only",
        },
        sources: {
          object_mode: "existing_only",
        },
      },
    },
    behavioral_ports: undefined,
    interface_ports: undefined,
    performs: {
      object_mode: "existing_only",
    },
    satisfies: {
      object_mode: "existing_only",
    },
    allocated_to: {
      object_mode: "existing_only",
    },
    requirements: {
      derives_from: {
        object_mode: "existing_only",
      },
      sources: {
        object_mode: "existing_only",
      },
    },
    actions: undefined,
    stakeholder_needs: undefined,
  },
  NumericAttribute: {
    canonical_unit: {
      object_mode: "existing_only",
    },
  },
  Organisation: {
    groups: {
      holders: {
        object_mode: "existing_only",
      },
    },
  },
  PDMAction: {
    requirements: undefined,
    sub_actions: undefined,
    performed_by: undefined,
  },
  PDMPart: {
    ports: undefined,
    sub_parts: undefined,
  },
  PDMProduct: {
    requirements: undefined,
    actions: undefined,
    supply_chain: undefined,
  },
  PDMRequirement: undefined,
  PDMSupplyChainCriteria: undefined,
  PhysicalPart: {
    parent: {
      object_mode: "existing_only",
    },
    children: undefined,
  },
  PhysicsPort: {
    owner: {
      object_mode: "existing_only",
    },
    bound_to: {
      object_mode: "existing_only",
    },
  },
  Project: {
    physical_parts: undefined,
    software_parts: undefined,
  },
  Questionnaire: {
    questions: {
      object_mode: "existing_only",
      answer: undefined,
    },
  },
  RFLPTask: {
    thread: {
      steps: {
        object_mode: "new_only",
        context_items: undefined,
      },
    },
    currently_attached_to: undefined,
  },
  Requirement: {
    sub_requirements: {
      derives_from: {
        object_mode: "existing_only",
      },
      refines: {
        object_mode: "existing_only",
      },
      conflicts_with: {
        object_mode: "existing_only",
      },
      sources: {
        object_mode: "existing_only",
      },
      transformed_from: {
        object_mode: "existing_only",
      },
      frames_concerns: {
        object_mode: "existing_only",
      },
    },
    container: {
      object_mode: "existing_only",
    },
    derives_to: {
      object_mode: "existing_only",
    },
    derives_from: {
      object_mode: "existing_only",
    },
    conflicts_with: {
      object_mode: "existing_only",
    },
    sources: {
      object_mode: "existing_only",
    },
    transformed_from: {
      object_mode: "existing_only",
    },
    frames_concerns: {
      object_mode: "existing_only",
    },
  },
  SoftwarePart: {
    parent: {
      object_mode: "existing_only",
    },
    children: undefined,
  },
  SourceDocument: undefined,
  StakeholderNeed: {
    transformed_to: {
      object_mode: "existing_only",
    },
    container: {
      object_mode: "existing_only",
    },
  },
  Standard: undefined,
  Step: {
    model_requests: {
      max_count: 10,
    },
  },
  Succession: {
    source_action: {
      object_mode: "existing_only",
    },
    target_action: {
      object_mode: "existing_only",
    },
    parent_action: {
      object_mode: "existing_only",
    },
    mentions: {
      object_mode: "existing_only",
    },
  },
  Thread: {
    steps: {
      max_count: 50,
      model_requests: {
        max_count: 10,
      },
    },
    context_items: {
      max_count: 20,
    },
  },
  Unit: undefined,
};

/**
 * Get the ConstructionSpec for a model's create operation
 */
export function getCreateConstructionSpec(modelName: string): ConstructionSpec | undefined {
  return CREATE_CONSTRUCTION_SPECS[modelName];
}

/**
 * Get the ConstructionSpec for a model's modify operation
 */
export function getModifyConstructionSpec(modelName: string): ConstructionSpec | undefined {
  return MODIFY_CONSTRUCTION_SPECS[modelName];
}

/**
 * Check if a relationship field is allowed in the ConstructionSpec
 */
export function isRelationshipAllowed(
  spec: ConstructionSpec | undefined,
  fieldName: string
): boolean {
  if (!spec) return false;
  return fieldName in spec && fieldName !== 'max_count';
}

/**
 * Get nested ConstructionSpec for a relationship field
 */
export function getNestedSpec(
  spec: ConstructionSpec | undefined,
  fieldName: string
): ConstructionSpec | undefined {
  if (!spec) return undefined;
  const value = spec[fieldName];
  return typeof value === 'object' ? value as ConstructionSpec : undefined;
}
